import { Button } from './ui/button';

export interface ChatSuggestion {
  id: string;
  text: string;
  response?: string;
}

interface ChatSuggestionsProps {
  suggestions: ChatSuggestion[];
  onSelect: (suggestion: ChatSuggestion) => void;
  disabled?: boolean;
}

export function ChatSuggestions({ suggestions, onSelect, disabled = false }: ChatSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-3">
      {suggestions.map((suggestion, index) => (
        <Button
          key={suggestion.id}
          variant="outline"
          size="sm"
          onClick={() => onSelect(suggestion)}
          disabled={disabled}
          className="suggestion-chip text-xs hover:bg-primary/10 hover:text-primary hover:border-primary/50 transition-all duration-200 hover:shadow-md active:scale-95"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          {suggestion.text}
        </Button>
      ))}
    </div>
  );
}
